<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.infraestruturas.filter(infraestrutura => infraestrutura.deleted === false)"
        >
            <template v-slot:cell(enviaSms)="{item}">
                <rkm-form-checkbox v-model="item.enviaSms" />
            </template>

            <template v-slot:cell(faturaProcedimentoRaas)="{item}">
                <rkm-form-checkbox v-model="item.faturaProcedimentoRaas" />
            </template>

            <template v-slot:cell(actions)="{index, item}">
                <rkm-button
                    @click="$refs.ModalAssinatura.open(item)"
                    small
                    title="Configuração de assinatura eletrônica"
                >
                    <rkm-icon icon="signature" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalOcupacao.open(item)"
                    color="success"
                    small
                    title="Configuração de CBO"
                >
                    <rkm-icon icon="cog" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalEspecialidade.open(item)"
                    color="warning"
                    small
                    title="Configuração de especialidade"
                >
                    <rkm-icon icon="cog" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalLocalAtendimentoAgendador.open(item)"
                    color="dark"
                    small
                    title="Local de atendimento agendador"
                >
                    <rkm-icon icon="building" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalServico.open(item)"
                    color="info"
                    small
                    title="Serviço"
                >
                    <rkm-icon icon="stream" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalSms.open(item)"
                    color="primary"
                    small
                    title="Configuração de SMS"
                >
                    <rkm-icon icon="sms" />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalOcupacao
            :data="{form: data.form}"
            ref="ModalOcupacao"
        />

        <ModalAssinatura
            :data="{form: data.form}"
            ref="ModalAssinatura"
        />

        <ModalEspecialidade ref="ModalEspecialidade" />

        <ModalLocalAtendimentoAgendador
            :data="{form: data.form}"
            ref="ModalLocalAtendimentoAgendador"
        />

        <ModalServico
            :data="{form: data.form}"
            ref="ModalServico"
        />

        <ModalSms ref="ModalSms" />
    </div>
</template>

<script>
// Components.
import ModalEspecialidade from './components/especialidade/Modal'
import ModalLocalAtendimentoAgendador from './components/local-atendimento-agendador/Modal'
import ModalAssinatura from './components/assinatura/Modal'
import ModalOcupacao from './components/ocupacao/Modal'
import ModalServico from './components/servico/Modal'
import ModalSms from './components/sms/Modal'

export default {
    components: {
        ModalEspecialidade,
        ModalLocalAtendimentoAgendador,
        ModalOcupacao,
        ModalAssinatura,
        ModalServico,
        ModalSms,
    },
    data: () => ({
        fields: [
            {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
            {key: 'nome', label: 'Local de atendimento', sortable: true},
            {key: 'enviaSms', label: 'Envia SMS'},
            {key: 'faturaProcedimentoRaas', label: 'Fatura procedimento RAAS'},
            {key: 'actions', label: 'Ações', class: 'col-min text-center'},
        ],
    }),
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o local de atendimento?', async () => {
                this.data.model.infraestruturas[index].deleted = true
            })
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>